<template>
    <main class="max-w-3xl mx-auto my-40 p-6">
        <h1 class="text-3xl font-bold mb-6">Politique de Confidentialité – My Profolia</h1>

        <p class="mb-6">
            Nous accordons une grande importance à la protection de vos données personnelles. Cette page décrit comment
            nous collectons, utilisons et protégeons vos informations conformément au Règlement Général sur la
            Protection des Données (RGPD).
        </p>

        <section class="mb-6">
            <h2 class="text-xl font-semibold mb-2">1. Données collectées</h2>
            <p>
                Nous collectons les données nécessaires à la création et gestion de votre page professionnelle : nom,
                adresse, logo, activité, description, horaires, réseaux sociaux, tarifs, ainsi que vos coordonnées
                (email, téléphone).
            </p>
            <p class="mt-2">
                Les informations de paiement sont traitées directement par notre prestataire Stripe, nous ne stockons
                pas vos données bancaires.
            </p>
        </section>

        <section class="mb-6">
            <h2 class="text-xl font-semibold mb-2">2. Utilisation des données</h2>
            <ul class="list-disc list-inside">
                <li>Gérer votre compte et votre abonnement</li>
                <li>Assurer la publication et la mise à jour de votre page professionnelle</li>
                <li>Communiquer avec vous (support, informations importantes)</li>
                <li>Respecter nos obligations légales</li>
            </ul>
        </section>

        <section class="mb-6">
            <h2 class="text-xl font-semibold mb-2">3. Cookies utilisés</h2>
            <p>
                Nous utilisons uniquement Google Analytics pour collecter des données anonymes sur la manière dont les
                visiteurs utilisent notre site. Ces données nous aident à améliorer l'expérience utilisateur.
            </p>
            <p>
                Pour en savoir plus sur Google Analytics et les cookies qu’il utilise, cliquez ici :
                <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener"
                    class="text-violet-500 underline">
                    politique Google Analytics
                </a>.
            </p>
        </section>

        <section class="mb-6">
            <h2 class="text-xl font-semibold mb-2">4. Consentement</h2>
            <p>
                Lors de votre première visite, une bannière de consentement s’affiche. Vous pouvez choisir d’accepter ou
                de refuser l’utilisation de ces cookies. Vous pouvez modifier votre choix à tout moment.
            </p>
        </section>

        <section class="mb-6">
            <h2 class="text-xl font-semibold mb-2">5. Désactivation des cookies</h2>
            <p>
                Vous pouvez supprimer ou bloquer les cookies en modifiant les paramètres de votre navigateur. Pour
                bloquer Google Analytics globalement, vous pouvez installer ce module complémentaire proposé par Google
                :
                <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener"
                    class="text-violet-500 underline">
                    module Google Analytics Opt-out
                </a>.
            </p>
        </section>

        <section class="mb-6">
            <h2 class="text-xl font-semibold mb-2">6. Durée de conservation</h2>
            <p>
                Nous conservons vos données pendant la durée de votre abonnement et jusqu’à 3 ans après la fin de
                celui-ci, conformément aux obligations légales.
            </p>
        </section>

        <section class="mb-6">
            <h2 class="text-xl font-semibold mb-2">7. Partage des données</h2>
            <p>
                Vos données ne sont pas vendues. Elles peuvent être partagées uniquement avec nos prestataires
                (hébergement, Stripe pour les paiements) et, si nécessaire, avec les autorités compétentes.
            </p>
        </section>

        <section class="mb-6">
            <h2 class="text-xl font-semibold mb-2">8. Sécurité</h2>
            <p>
                Nous mettons en place des mesures techniques et organisationnelles pour protéger vos données contre tout
                accès non autorisé ou perte.
            </p>
        </section>

        <section class="mb-6">
            <h2 class="text-xl font-semibold mb-2">9. Vos droits</h2>
            <p>Vous avez le droit de :</p>
            <ul class="list-disc list-inside mb-2">
                <li>Accéder à vos données</li>
                <li>Les rectifier</li>
                <li>Demander leur suppression sous certaines conditions</li>
                <li>Limiter ou vous opposer à leur traitement</li>
                <li>Retirer votre consentement à tout moment</li>
                <li>Demander la portabilité de vos données</li>
            </ul>
            <p>Pour exercer ces droits, contactez-nous à : <a href="mailto:contact@myprofolia.com"
                    class="text-violet-500 underline">contact@myprofolia.com</a></p>
        </section>

        <section class="mb-6">
            <h2 class="text-xl font-semibold mb-2">10. Droit de réclamation</h2>
            <p>
                Si vous estimez que vos droits ne sont pas respectés, vous pouvez contacter la CNIL :
                <a href="https://www.cnil.fr" target="_blank" rel="noopener"
                    class="text-violet-500 underline">www.cnil.fr</a>.
            </p>
        </section>

        <section>
            <h2 class="text-xl font-semibold mb-2">11. Contact</h2>
            <p>
                Pour toute question concernant vos données personnelles, veuillez nous contacter à :
                <a href="mailto:contact@myprofolia.com" class="text-violet-500 underline">contact@myprofolia.com</a>
            </p>
        </section>
    </main>
</template>

<script setup>
// Pas de logique particulière pour cette page statique
</script>

<style scoped>
/* Tu peux ajouter ici ton CSS personnalisé */
</style>
